<form
  #form="ngForm"
  class="location-residential location-residential--residential"
  id="confirmAddress"
  name="formBillingAddress"
  novalidate>

  <div class="form-group form-group-lg margin-bottom-32" [ngClass]="{ 'hidden' : !showManualInput }">
    <input class="form-control box-shadow"
      [ngClass]="{ 'has-error' : collectionAddressLine1.invalid && collectionAddressLine1.dirty || errorNoPostcode }"
      id="collectionAddressLine1"
      name="collectionAddressLine1"
      ngControl="collectionAddressLine1"
      #collectionAddressLine1="ngModel"
      [(ngModel)]="locationData.addressLine1"
      type="text"
      required
      appCheckEmpty>
    <label class="control-label" for="collectionAddressLine1">{{appCopy.panelHeader['collectionAddressLineLabel'+selectedLanguage]}}</label>
    <a class="control-btn"
      (click)="clearInput()"
      href="javascript:void(0)">
      <i class="icon">cross</i>
    </a>
    <p class="help-block text-danger" *ngIf="collectionAddressLine1.invalid && collectionAddressLine1.dirty || errorNoPostcode">{{appCopy.panelHeader['errorTextCollectionAddressLine'+selectedLanguage]}}</p>
  </div>

  <div class="form-group form-group-lg margin-bottom-32" [ngClass]="{ 'hidden' : showManualInput }">
    <!-- placeholder="Search for your billing address"
    [selectedAddressLine]="selectedAddressLine"
    [errorNoPostcode]="errorNoPostcode"
    [errorPostcodeNotEntered]="errorPostcodeNotEntered"
    (changedAddressLine)="changedAddressLine($event)"
    (selectedLocationResidential)="getChildLocation($event)"
    (showManualInput)="showManualInput = true" -->
    <app-location-residential-lookup
    [placeholder]="addressplaceHolder"
    [userAddresses]="[]"
    [selectedAddressLine]="selectedAddressLine"
    [errorNoPostcode]="errorNoPostcode"
    [errorPostcodeNotEntered]="errorPostcodeNotEntered"
    [isInternational]="true"
    (changedAddressLine)="changedAddressLine($event)"
    (selectedLocationResidential)="getChildLocation($event)"
    (selectedSavedLocationResidential)="selectedSavedLocationResidential($event)"
    (showManualInput)="showManualInput = true"
    (toggleShowMenu)="toggleShowMenu($event)">
    </app-location-residential-lookup>
  </div>

  <a class="link" href="javascript:void(0)" (click)="showManualInput = true" *ngIf="!showManualInput">{{appCopy.panelHeader['titleInternationalAddress'+selectedLanguage]}}</a>

  <div *ngIf="showManualInput">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <input class="form-control"
            [ngClass]="{ 'has-error': collectionAddressLine2.invalid && collectionAddressLine2.dirty || isInvalidCollectionAddressLine2 }"
            id="collectionAddressLine2"
            name="collectionAddressLine2"
            ngControl="collectionAddressLine2"
            #collectionAddressLine2="ngModel"
            [(ngModel)]="locationData.addressLine2"
            (keyup)="addressChaneHandler($event)"
            type="text"
            autocomplete="off"
            required
            appCheckEmpty>
          <label class="control-label" for="collectionAddressLine2">{{appCopy.panelHeader['collectionAddressLineTwoLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>
          <p class="help-block text-danger" *ngIf="collectionAddressLine2.invalid && collectionAddressLine2.dirty || isInvalidCollectionAddressLine2">{{appCopy.panelHeader['errorTextCollectionAddressLineTwo'+selectedLanguage]}}</p>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input #postcodeElement
            class="form-control"
            [ngClass]="{ 'has-error' : collectionAddressPostcode.invalid && collectionAddressPostcode.dirty || postcodeInvalid || isInvalidCollectionAddressPostcode}"
            id="collectionAddressPostcode"
            name="collectionAddressPostcode"
            ngControl="collectionAddressPostcode"
            #collectionAddressPostcode="ngModel"
            [(ngModel)]="locationData.addressPostCode"
            (keyup)="addressChaneHandler($event)"
            type="text"
            minlength="4"
            maxlength="12"
            autocomplete="off"
            required
            appCheckEmpty>
          <label class="control-label" for="collectionAddressPostcode">{{appCopy.panelHeader['collectionAddressPostcodeLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state" *ngIf="!postcodeCheck"></i>
          <div class="loader-container-typeahead" *ngIf="postcodeCheck">
            <div class="loader loader--gray">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
          <p class="help-block text-danger" *ngIf="collectionAddressPostcode.invalid && collectionAddressPostcode.dirty || isInvalidCollectionAddressPostcode">{{appCopy.panelHeader['errorTextCollectionAddressPostcodeRequired'+selectedLanguage]}}</p>
          <p class="help-block text-danger" *ngIf="postcodeInvalid">{{appCopy.panelHeader['errorTextCollectionAddressPostcodeOutOfCoverage'+selectedLanguage]}}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <input class="form-control"
            [ngClass]="{ 'has-error' : collectionAddressTown.invalid && collectionAddressTown.dirty || cityInvalid || isInvalidCollectionAddressTown }"
            id="collectionAddressTown"
            name="collectionAddressTown"
            ngControl="collectionAddressTown"
            #collectionAddressTown="ngModel"
            [(ngModel)]="locationData.addressTown"
            (keyup)="addressChaneHandler($event)"
            type="text"
            autocomplete="off"
            required
            appCheckEmpty>
          <label class="control-label" for="collectionAddressTown">{{appCopy.panelHeader['collectionAddressTownLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>
          <p class="help-block text-danger" *ngIf="collectionAddressTown.invalid && collectionAddressTown.dirty || cityInvalid || isInvalidCollectionAddressTown">{{appCopy.panelHeader['errorTextCollectionAddressTownRequired'+selectedLanguage]}}</p>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <input class="form-control"
            [ngClass]="{ 'has-error' : collectionAddressCounty.invalid && collectionAddressCounty.dirty || isValidCollectionAddressCounty }"
            id="collectionAddressCounty"
            name="collectionAddressCounty"
            ngControl="collectionAddressCounty"
            #collectionAddressCounty="ngModel"
            [(ngModel)]="locationData.addressCounty"
            (keyup)="addressChaneHandler($event)"
            type="text"
            autocomplete="off"
            required
            appCheckEmpty>
          <label class="control-label" for="collectionAddressCounty">{{appCopy.panelHeader['collectionAddressCountyLabel'+selectedLanguage]}}</label>
          <i class="icon control-validation-state"></i>
          <p class="help-block text-danger" *ngIf="collectionAddressCounty.invalid && collectionAddressCounty.dirty || isValidCollectionAddressCounty">{{appCopy.panelHeader['errorTextCollectionAddressCountyRequired'+selectedLanguage]}}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group with-select margin-bottom-0">
          <select class="form-control"
            [ngClass]="{ 'has-error' : collectionAddressCountry.invalid && collectionAddressCountry.dirty || isInvalidCollectionAddressCountry }"
            id="collectionAddressCountry"
            name="collectionAddressCountry"
            #collectionAddressCountry="ngModel"
            [(ngModel)]="locationData.addressCountry"
            required
            appCheckEmpty>

            <option *ngFor="let item of countries.featured" [value]="item.countryName">{{ item.countryName }}</option>
            <optgroup label="Other countries">
              <option *ngFor="let item of countries.all" [value]="item.countryName">{{ item.countryName }}</option>
            </optgroup>

          </select>
          <label class="control-label" for="collectionAddressCountry">{{appCopy.panelHeader['collectionAddressCountryLabel'+selectedLanguage]}}</label>
        </div>
      </div>
    </div>
  </div>

  <div class="alert alert-danger" *ngIf="formHasErrors">
    <p>{{appCopy.panelHeader['errorTextBillingAddress'+selectedLanguage]}}</p>
  </div>

</form>
